import {Component, Inject, Input, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
@Component({
  selector: 'app-mesa-partes-frameboard',
  templateUrl: './mesa-partes-frameboard.component.html',
  styleUrls: ['./mesa-partes-frameboard.component.scss']
})
export class MesaPartesFrameboardComponent implements OnInit {
    @Input() GeneralSearchActive = false

  showSearch = true
    guardado = false
    showPide: boolean = false;
  constructor(@Inject(DOCUMENT) private document: Document,) { }

  ngOnInit(): void {
      this.document.location.href.split('/').forEach(l => {
          if ( l === 'registro-guardado') {
              this.guardado = true
          }
      })

      this.verificarArea().then(() => {
      });
  }

  open(){}
    activar(l: string) {
        this.guardado = false

        if ( l === 'guardado') {
            this.guardado = true
        }
    }

    verificarArea() {
      return new Promise<void>((resolve) => {
        setTimeout(() => {
          const { idArea } = JSON.parse(localStorage.getItem('bandeja') || '{}');
          if(idArea!=47){ this.showPide = false }else{ this.showPide = true }
          resolve();
        }, 500);
      });
    }  
}
